import compileVariableUtil from '../../../../static/js/compileVariableUtil'
import templateUtil from '../../../../static/js/templateUtil'
// import templateUtil from '../templateUtil';

export default function (validateItem, formItem, fCreateApi) {
  if (validateItem.type) validateItem.customType = validateItem.type //用于取缓存数据时type为null，导致不执行该方法从而取不到formData
  validateItem.type = null

  validateItem.trigger = 'blur'
  validateItem.validator = (rule, value, callback, souce, op) => {
    var formData = fCreateApi.getFormData()

    if (validateItem.parameter) {
      var msg = validateItem.message
      if (!msg) msg = '不满足校验条件'

      var propsCompileData = compileVariableUtil.getCompileVariable(fCreateApi.getFormData(), this)

      let propsCompile = null
      try {
        propsCompile = templateUtil.compileData(validateItem.parameter, propsCompileData)
      } catch (e) {
        console.error(e)
      }

      var validateFlag = propsCompile ? propsCompile.equalExpression : true

      if (rule.required && !value && value !== 0 && value !== false) {
        validateFlag = false
      }

      if (validateFlag) {
        if (callback) callback()
      } else {
        if (callback) callback(new Error(msg))
      }
    }

    // console.log("validateConverterUtil.converterAdapter:validateItem",
    //   validateItem);
  }
}
